import React from "react";
import Card from "./Card.js";

const DisclaimerCard = ({ title, children }) => (
  <Card className="provider-beta__disclaimer-card">
    <h3 className="provider-beta__disclaimer-title">{title}</h3>
    <div className="provider-beta__disclaimer-body">{children}</div>
  </Card>
);

export default DisclaimerCard;
